import React from 'react';

export const iconCalendar = classNames => (
	<svg viewBox="0 0 23 25" className={classNames + " svg-icon svg-calendar"} role="presentation"><title>icon-calendar</title><path d="M0,24a1,1,0,0,0,1,1H22a1,1,0,0,0,1-1V7H0ZM17,9h4v4H17Zm0,5h4v4H17Zm0,5h4v4H17ZM12,9h4v4H12Zm0,5h4v4H12Zm0,5h4v4H12ZM7,9h4v4H7Zm0,5h4v4H7Zm0,5h4v4H7ZM2,9H6v4H2Zm0,5H6v4H2Zm0,5H6v4H2ZM22,3H18V0H16V3H7V0H5V3H1A1,1,0,0,0,0,4V6H23V4A1,1,0,0,0,22,3Z"/></svg>
);